import {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
  useLayoutEffect,
} from "react";
import axios from "axios";
import { useParams, Link, useHistory, useLocation } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import { isIPad13, isMacOs } from "react-device-detect";
import * as queryString from "query-string";
import dayjs from "dayjs";
import PropTypes from "prop-types";

import { Button, Col, Container, Modal, Row } from "react-bootstrap";

import {
  getSingleTopic,
  doRestartTopicMessages,
  doSubscribeToTopic,
  doUnsubscribeToTopic,
  updateCustomTopic,
  deleteTopicGroup,
  getUserSubscription,
} from "../../actions/topicActions";

import {
  setAdditionalParams,
  setSubscriptionFrequency,
  setSubscriptionTypes,
} from "../../actions/subscription";

import {
  getFilter,
  getRegulatoryStream,
  getTop5Publisher,
  getTop5Countries,
  getGraphAggregations,
  getGraphAggregationsDetails,
  getHotTopicsPerBusiness,
  getFilterTypes,
  addFilter,
  deleteFilter,
  deleteNewsById,
  // addNewsItem,
  // editNewsItem,
  addNewsItemAction,
  filterSuccessMessageRaised,
  filterFailureMessageRaised,
  editNewsItemAction,
  regulatoryStreamsAreClean,
} from "../../actions/filterActions";
import { aIResponseCloseModal } from "../../actions/askQuestion";
import {
  getTiles,
  getTilesOfTypeLinks,
  getTileTypes,
} from "../../actions/tileActions";

import {
  LOG_IN,
  REGISTER,
  FALSE,
  WORKSPACE_TYPE_PRIVATE,
} from "../../constants/stringConstants";
import {
  ADD_NEWS,
  EDIT_NEWS,
  GET_REGULATORY_STREAM,
  REG_HUB_ADD_TOPIC,
} from "../../constants/urls";

import Loader from "../../utils/Loader";
import TabsCustom from "../../utils/TabsCustom";
import CustomModal from "../../utils/CustomModal";
import FieldsInForm from "../../utils/FieldsInForm";
import { formatDate } from "../../utils/formatDate";
import AlertMessage from "../../utils/AlertMessage";
import ErrorMessage from "../../utils/ErrorMessage";
import useWindowDimensions from "../../utils/useWindowDimensions";

import iconSubscribe from "../../assets/svg/icons-subscribe.svg";
import iconsShare from "../../assets/svg/icons-share.svg";
import iconsJson from "../../assets/svg/icons-json.svg";
import iconsEdit from "../../assets/svg/icons-edit.svg";
import iconsDelete from "../../assets/svg/icons-delete.svg";
import iconsSubscribeChecked from "../../assets/svg/icons-subscribe-checked.svg";

import Footer from "../FooterComponents/Footer";
import OverviewLargeScreenContainer from "../OverviewComponents/OverviewLargeScreenContainer";
import OverviewSmallScreenContainer from "../OverviewComponents/OverviewSmallScreenContainer";
import AssessmentContainer from "../AssessmentComponents/AssessmentContainer";
import { addArrayAction } from "../../actions/newsListActions";
// import { getDateHelper } from "../../helpers/getDateHelpers";

const STREAM_PAGE_NUMBER = 0;
const STREAM_PAGE_MAX_SIZE = 10;

const TopicHomePageContainer = ({
  userToken,
  getSingleTopic,
  singleTopicIsLoadedWithError,
  singleTopicIsLoading,
  singleTopic,
  loggedIn,
  doRestartTopicMessages,
  topicErrorMessage,
  topicSuccessMessage,
  doSubscribeToTopic,
  doUnsubscribeToTopic,
  getUserSubscription,
  getFilter,
  getRegulatoryStream,
  getTop5Publisher,
  getTop5Countries,
  getGraphAggregations,
  getGraphAggregationsDetails,
  getHotTopicsPerBusiness,
  filterSuccessMessage,
  filterFailureMessage,
  getFilterTypes,
  filtersTypes,
  addFilter,
  currentWorkspace,
  filters,
  deleteFilter,
  deleteNewsById,
  getTiles,
  getTileTypes,
  user,
  updateCustomTopic,
  deleteTopicGroup,
  // addNewsItem,
  // editNewsItem,
  graphAggregationsDetails,
  regulatoryStream,
  getTilesOfTypeLinks,
}) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const history = useHistory();
  const { pathname, search } = useLocation();
  const { width } = useWindowDimensions();

  const isCustomTopic = useMemo(
    () =>
      user.USER_EMAIL === singleTopic.CREATED_BY &&
      singleTopic.TOPIC_TYPE === "TOPIC",
    [singleTopic.CREATED_BY, singleTopic.TOPIC_TYPE, user.USER_EMAIL]
  );
  const [failureMessage, setFailureMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [selectedTab, setSelectedTab] = useState(null);
  const [isShared, setIsShared] = useState();
  const [askAQuestionModal, setAskAQuestionModal] = useState(false);
  const [subscribeModal, setSubscribeModal] = useState(false);
  const [addNewsModal, setAddNewsModal] = useState(false);
  const [editNewsModal, setEditNewsModal] = useState(null);
  const [newsTopics, setNewsTopics] = useState([]);
  const [newsDate, setNewsDate] = useState("");
  const [newsDateEditForm, setNewsDateEditForm] = useState("");
  const [newsTopicsEditForm, setNewsTopicsEditForm] = useState([]);
  const [submitNewsOccurred, setSubmitNewsOccurred] = useState(false);
  const [submitEditNewsOccurred, setSubmitEditNewsOccurred] = useState(false);
  const [toDate, setToDate] = useState("");
  const [fromDate, setFromDate] = useState(() => {
    const searchParams = queryString.parse(search);
    const searchDate = searchParams.fromDate;
    // const searchParams = new URLSearchParams(location.search);
    // let searchDate = searchParams.get("fromDate");
    if (searchDate) return searchDate;
    let d = new Date();
    d.setDate(d.getDate() - 90);
    return d;
  });
  const [macOSToDate, setMacOSToDate] = useState(new Date()); // * maybe this code is useless
  const [macOSFromDate, setMacOSFromDate] = useState(() => {
    let d = new Date();
    d.setDate(d.getDate() - 90);
    return d;
  });

  const checkSuccess = JSON.parse(sessionStorage.getItem("success"));
  useEffect(() => {
    if (checkSuccess) {
      setAskAQuestionModal(false);
    }
  }, [checkSuccess, setAskAQuestionModal]);

  useEffect(() => {
    setToDate(new Date());
    sessionStorage.setItem("toDate", formatDate(new Date()));
  }, []);

  sessionStorage.setItem("fromDate", formatDate(fromDate));

  const [page, setPage] = useState(0);
  const [freeText, setFreeText] = useState("");
  const [publicationTypes, setPublicationTypes] = useState([]);

  const [publisherTypes, setPublisherTypes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [topicsAndUnits, setTopicsAndUnits] = useState([]);

  const [countriesDataSet, setCountriesDataSet] = useState([]);
  const [topicsAndUnitsDataSet, setTopicsAndUnitsDataSet] = useState([]);
  const [publicationTypesDataSet, setPublicationTypesDataSet] = useState([]);
  const [publisherTypesDataSet, setPublisherTypesDataSet] = useState([]);

  const [sortField, setSortField] = useState("");
  const [sortDirection, setSortDirection] = useState("DESC");
  // eslint-disable-next-line no-unused-vars
  const [filter_name, setFilterName] = useState("");
  const [filter_audience, setFilterAudience] = useState(WORKSPACE_TYPE_PRIVATE);
  const [raiseSaveFilterModal, setRaiseSaveFilterModal] = useState(false);
  const [
    graphAggregationsDetailsFormatted,
    setGraphAggregationsDetailsFormatted,
  ] = useState([]);
  const [
    submitForCreationOfFilterOccured,
    setSubmitForCreationOfFilterOccured,
  ] = useState(false);
  const [
    multiFilterRadioButtonsValue,
    setMultiFilterRadioButtonsValue,
  ] = useState(() => {
    // const searchParams = new URLSearchParams(location.search);
    // let searchDate = searchParams.get("fromDate");
    const searchParams = queryString.parse(search);
    const searchDate = searchParams.fromDate;
    if (searchDate) return searchDate;
    return "today - 90";
  });

  const [newsIdForDeletion, setNewsIdForDeletion] = useState(null);
  const [raiseManageFiltersModal, setRaiseManageFiltersModal] = useState(false);
  const [changeRadioButtonValue, setChangeRadioButtonValue] = useState(0);
  const [isAddEditDialogShown, setIsAddEditDialogShown] = useState(false);
  const [editTopicOccurred, setEditTopicOccurred] = useState(false);
  const [isDeletedDialogOpened, setIsDeletedDialogOpened] = useState(false);

  const [didMount, setDidMount] = useState(false);
  const [didParsedSearch, setDidParsedSearch] = useState(false);
  const [otherRequestCalled, setOtherRequestCalled] = useState(false);
  const [initialRender, setInitialRender] = useState(true);

  const dispatch = useDispatch();

  // eslint-disable-next-line react-redux/useSelector-prefer-selectors
  const getPageFromStore = useSelector((state) => state.addPageReducer);

  const getTopicNameFromStorage = sessionStorage.getItem("TOPIC_SEARCHTAGS");
  const freeTextValue = sessionStorage.getItem("freeText");
  console.log("freeTextValue", freeTextValue);
  useEffect(() => {
    if (freeTextValue !== null) {
      setFreeText(freeTextValue);
    } else {
      setFreeText("");
    }
  }, [freeTextValue]);

  const handlePagination = useCallback(async () => {
    try {
      let countriesMultipleString = "";
      let topicsAndUnitsTypesString = "";
      countries.forEach((country) => {
        countriesMultipleString += country.description + ";";
      });
      topicsAndUnits.forEach((topicOrUnit) => {
        topicsAndUnitsTypesString += topicOrUnit.description + ";";
      });
      console.log("type === handlePagination");
      let publication = sessionStorage.getItem("publicationTypes");
      let publisher = sessionStorage.getItem("publisherTypes");
      let from = sessionStorage.getItem("fromDate");
      let to = sessionStorage.getItem("toDate");

      if (getTopicNameFromStorage) {
        await getRegulatoryStream(
          userToken,
          singleTopic.TOPIC_ID,
          freeText,
          getTopicNameFromStorage,
          publication,
          from,
          to,
          publisher,
          countriesMultipleString,
          topicsAndUnitsTypesString,
          page,
          STREAM_PAGE_MAX_SIZE,
          sortField,
          sortDirection
        );
        if (initialRender) {
          setPage(0);
          setInitialRender(false);
        } else {
          setPage((prevPage) => prevPage + 1);
        }
      }
    } catch (error) {
      console.log("error handlePagination", error);
    }
  }, [
    initialRender,
    countries,
    freeText,
    getRegulatoryStream,
    getTopicNameFromStorage,
    page,
    singleTopic.TOPIC_ID,
    sortDirection,
    sortField,
    topicsAndUnits,
    userToken,
  ]);

  const showDeleteNewsModal = useCallback((id) => {
    setNewsIdForDeletion(id);
  }, []);

  const hideDeleteNewsModal = useCallback(() => {
    setNewsIdForDeletion(null);
  }, []);

  // eslint-disable-next-line react-redux/useSelector-prefer-selectors
  // const dataFromStore = useSelector((state) => {
  //   return state.newsListReducer;
  // });

  const approveDeleteNewsModal = useCallback(async () => {
    deleteNewsById(userToken, newsIdForDeletion);
    hideDeleteNewsModal();
    // let updatedData = dataFromStore.filter(
    //   (item) => item.id !== newsIdForDeletion
    // );
    // dispatch(addArrayAction(updatedData));
    dispatch(regulatoryStreamsAreClean());
    setPage(getPageFromStore);

    let publication = sessionStorage.getItem("publicationTypes");
    let country = sessionStorage.getItem("country");
    let publisher = sessionStorage.getItem("publisherTypes");
    let from = sessionStorage.getItem("fromDate");
    let to = sessionStorage.getItem("toDate");
    let topicsAndUnitsTypesString = "";
    topicsAndUnits.forEach((topicOrUnit) => {
      topicsAndUnitsTypesString += topicOrUnit.description + ";";
    });
    setTimeout(() => {
      getRegulatoryStream(
        userToken,
        singleTopic.TOPIC_ID,
        freeText,
        getTopicNameFromStorage,
        publication,
        from,
        to,
        publisher,
        country,
        topicsAndUnitsTypesString,
        STREAM_PAGE_NUMBER,
        STREAM_PAGE_MAX_SIZE,
        sortField,
        "DESC"
      );
    }, 1000);
  }, [
    deleteNewsById,
    dispatch,
    freeText,
    getPageFromStore,
    getRegulatoryStream,
    getTopicNameFromStorage,
    hideDeleteNewsModal,
    newsIdForDeletion,
    singleTopic.TOPIC_ID,
    sortField,
    topicsAndUnits,
    userToken,
  ]);

  const argsForCreationOfNewFilterSet = {
    fields: [
      {
        name: "FILTER_NAME",
        type: "text",
        className: "register-login-text-field",
        required: true,
        classnameofgroup: "register-login-text-field-group",
        label: t("nameTheSet"),
        placeholder: t("egEuropeanBakingRegulations"),
      },
      {
        name: "WORKSPACE_RADIO_BUTTONS",
        type: "multi-radiobuttons",
        className: "register-login-text-field",
        required: false,
        classnameofgroup:
          currentWorkspace.WORKSPACE_TYPE === WORKSPACE_TYPE_PRIVATE
            ? "register-login-text-field-group cursor-not-allowed"
            : "register-login-text-field-group cursor-pointer",
        data: [
          {
            description: t("privateFilterSet"),
            value: "private",
            subdescription: t("visibleOnlyToYou"),
          },
          {
            description: t("teamFilterSet"),
            value: "public",
            subdescription: t("visibleToEveryoneInYourTeam"),
          },
        ],
        displayProperty: "description",
        valueProperty: "value",
        subDisplayProperty: "subdescription",
        defaultChecked: WORKSPACE_TYPE_PRIVATE,
        disabled: currentWorkspace.WORKSPACE_TYPE === WORKSPACE_TYPE_PRIVATE,
        onRadioButtonChange: (value) => {
          setFilterAudience(value);
        },
      },
    ],
    findFormErrors: (form) => {
      const { FILTER_NAME } = form;
      const newErrors = {};

      if (!FILTER_NAME || FILTER_NAME === "")
        newErrors.FILTER_NAME = "Filter name is mandatory field";
      else if (FILTER_NAME.length > 255)
        newErrors.FILTER_NAME =
          "Filter name can't be longer than 255 charachteres";
      else setFilterName(FILTER_NAME);

      return newErrors;
    },
    classNameReactFormal: "register-login-react-formal",
    classNameForm: "register-login-react-form",
    onSubmit: (values) =>
      preparationOfDataBeforeOperation("addFilter", values.FILTER_NAME),
  };

  const argsForManageFilterSets = {
    fields: [
      {
        name: "FILTER_SET",
        type: "multiple-text-fields",
        className: "register-login-text-field",
        required: false,
        disabled: true,
        classnameofgroup: "register-login-text-field-group",
        label: t("fieldSetName"),
        data: filters,
        displayProperty: "FILTER_NAME",
        valueProperty: "FILTER_ID",
        onTextFieldDelete: (value) =>
          deleteFilter(userToken, value, singleTopic.TOPIC_ID),
      },
    ],
    classNameReactFormal: "register-login-react-formal",
    classNameForm: "register-login-react-form",
  };

  const addNewsFields = {
    fields: [
      {
        name: "NEWS_TITLE",
        type: "text",
        className: "news-title-text-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsTitle"),
        placeholder: t("newsTitlePlaceholder"),
      },
      {
        name: "NEWS_URL",
        type: "text",
        className: "news-url-text-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsURL"),
        placeholder: t("newsURLPlaceholder"),
      },
      {
        name: "NEWS_DESCRIPTION",
        type: "textarea",
        className: "news-description-textarea-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsDescription"),
        placeholder: t("newsDescriptionPlaceholder"),
      },
      {
        name: "NEWS_CONTENT",
        type: "textarea",
        className: "news-content-textarea-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsContent"),
        placeholder: t("newsContentPlaceholder"),
      },
      {
        name: "NEWS_PUBLISHER",
        type: "text",
        className: "news-publisher-text-field",
        required: true,
        classnameofgroup: "add-news-half-width-fields-group",
        label: t("newsPublisher"),
        placeholder: t("newsPublisherPlaceholder"),
      },
      {
        name: "NEWS_PUBLISHER_TYPE",
        type: "select",
        className: "news-publisher-type-select",
        classnameofgroup: "add-news-half-width-fields-group",
        options: [
          { description: "Please select", value: "Please select" },
          ...publisherTypesDataSet,
        ],
        required: true,
        disabled: false,
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsPublisherType"),
      },
      {
        name: "NEWS_PUBLICATION_TYPE",
        type: "select",
        className: "news-publication-type-select",
        classnameofgroup: "add-news-half-width-fields-group",
        required: true,
        disabled: false,
        options: [
          { description: "Please select", value: "Please select" },
          ...publicationTypesDataSet,
        ],
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsPublicationType"),
      },
      {
        name: "NEWS_DATE",
        type: "date",
        className: "news-date-field",
        classnameofgroup: "add-news-half-width-fields-group",
        label: t("newsDate"),
        required: true,
        options: [
          {
            key: "news-date",
            name: "NEWS_DATE",
            format: "YYYY/MM/DD",
            type: "date",
            disabled: false,
            value: formatDate(newsDate),
            onChangeDate: (value) => {
              setNewsDate(new Date(value));
            },
          },
        ],
      },
      {
        name: "NEWS_COUNTRY",
        type: "select",
        className: "news-country-select",
        classnameofgroup: "add-news-half-width-fields-group",
        options: [
          { description: "Please select", value: "Please select" },
          ...countriesDataSet,
        ],
        required: true,
        disabled: false,
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsCountry"),
      },
      {
        name: "NEWS_TOPICS",
        type: "multi-select",
        className: "news-topics-type-multiselect",
        classnameofgroup: "add-news-half-width-fields-group",
        required: true,
        disabled: false,
        options: topicsAndUnitsDataSet,
        selectedOptions: newsTopics,
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsTopics"),
        placeholder: t("newsTopicsPlaceholder"),
        onMultiSelectOptionChanged: (value, description) => {
          let found = newsTopics.find((el) => {
            return el.value === value;
          });

          if (!found) {
            setNewsTopics((newsTopics) => [
              ...newsTopics,
              {
                description: description,
                value: value,
              },
            ]);
          }
        },
        onMultiSelectOptionRemoved: (value) => {
          setNewsTopics(newsTopics.filter((o) => o.value !== value));
        },
      },
      {
        name: "NEWS_CURATED",
        type: "select",
        className: "news-curated-select",
        classnameofgroup: "add-news-half-width-fields-group",
        required: true,
        disabled: false,
        options: [
          { description: "Please select", value: "Please select" },
          { description: "No", value: "no" },
          { description: "Yes", value: "yes" },
        ],
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsCurated"),
      },
    ],
    findFormErrors: (form) => {
      const {
        NEWS_TITLE,
        NEWS_DESCRIPTION,
        NEWS_URL,
        NEWS_CONTENT,
        NEWS_PUBLISHER,
        NEWS_PUBLISHER_TYPE,
        NEWS_PUBLICATION_TYPE,
        NEWS_DATE,
        NEWS_COUNTRY,
        NEWS_CURATED,
      } = form;
      const newsErrors = {};

      if (!NEWS_TITLE || NEWS_TITLE === "") {
        newsErrors.NEWS_TITLE = "News title is mandatory field";
      }
      if (!NEWS_URL || NEWS_URL === "") {
        newsErrors.NEWS_URL = "News URL is mandatory field";
      }
      if (!NEWS_CONTENT || NEWS_CONTENT === "" || NEWS_CONTENT === undefined) {
        newsErrors.NEWS_CONTENT = "News content is mandatory field";
      }
      if (NEWS_DESCRIPTION && NEWS_DESCRIPTION.length > 1500)
        newsErrors.NEWS_DESCRIPTION =
          "News description can't be longer than 1500 charachteres";
      if (!NEWS_PUBLISHER || NEWS_PUBLISHER === "") {
        newsErrors.NEWS_PUBLISHER = "News publisher is mandatory field";
      }
      if (
        !NEWS_PUBLISHER_TYPE ||
        NEWS_PUBLISHER_TYPE === "" ||
        NEWS_PUBLISHER_TYPE === "Please select"
      ) {
        newsErrors.NEWS_PUBLISHER_TYPE =
          "News publisher type is mandatory field";
      }
      if (
        !NEWS_PUBLICATION_TYPE ||
        NEWS_PUBLICATION_TYPE === "" ||
        NEWS_PUBLICATION_TYPE === "Please select"
      ) {
        newsErrors.NEWS_PUBLICATION_TYPE =
          "News publication type is mandatory field";
      }
      if (!NEWS_DATE || NEWS_DATE === "") {
        newsErrors.NEWS_DATE = "News date is mandatory field";
      }
      if (
        !NEWS_COUNTRY ||
        NEWS_COUNTRY === "" ||
        NEWS_COUNTRY === "Please select"
      ) {
        newsErrors.NEWS_COUNTRY = "News country is mandatory field";
      }
      if (
        !NEWS_CURATED ||
        NEWS_CURATED === "" ||
        NEWS_CURATED === "Please select"
      ) {
        newsErrors.NEWS_CURATED = "News curated is mandatory field";
      }
      return newsErrors;
    },

    onSubmit: (values) => {
      let newsTopicsArr = [];
      newsTopics.map((item) => newsTopicsArr.push(item.description));
      let newsTopicsString = newsTopicsArr.join(";");

      let newsValues = {
        ...values,
        NEWS_TOPICS: newsTopicsString,
        NEWS_CURATED: values?.NEWS_CURATED || "no",
      };
      preparationOfDataBeforeOperation(
        "addNewsItem",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        newsValues
      );
      setAddNewsModal(false);
    },
  };

  const askAQuestionFields = {
    fields: [
      {
        name: "YOUR_QUESTION",
        type: "textarea",
        className: "ask-question-textarea-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("yourQuestion"),
        placeholder: t("yourQuestionPlaceholder"),
      },
      {
        name: "THE_ANSWER",
        type: "textarea",
        className: "answer-textarea-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("theAnswer"),
      },
    ],
    findFormErrors: (form) => {
      const { YOUR_QUESTION } = form;

      const newsErrors = {};
      if (!YOUR_QUESTION || YOUR_QUESTION === "") {
        newsErrors.YOUR_QUESTION = "Your Question is mandatory field";
      }
      return newsErrors;
    },
  };
  const frequencySubscriptionArr = [
    {
      description: "Don't send a newsletter",
      value: -1,
    },
    {
      description: "90",
      value: 90,
    },
    {
      description: "30",
      value: 30,
    },
    {
      description: "14",
      value: 14,
    },
    {
      description: "7",
      value: 7,
    },
    {
      description: "1",
      value: 1,
    },
  ];

  const typesSubscriptionArr = [
    {
      description: "All news",
      value: false,
    },
    {
      description: "Only curated news",
      value: true,
    },
  ];

  // eslint-disable-next-line react-redux/useSelector-prefer-selectors
  const additionalParams = useSelector(
    (state) => state.subscriptionReducer.additionalParams
  );
  // eslint-disable-next-line react-redux/useSelector-prefer-selectors
  const subscriptionFrequency = useSelector(
    (state) => state.subscriptionReducer.subscriptionFrequency
  );
  // eslint-disable-next-line react-redux/useSelector-prefer-selectors
  const subscriptionTypes = useSelector(
    (state) => state.subscriptionReducer.subscriptionTypes
  );

  const filteredSubscriptionFrequency = frequencySubscriptionArr?.filter(
    (option) => option.value !== subscriptionFrequency
  );

  const filteredOptions = typesSubscriptionArr.filter(
    (option) =>
      option.value !==
      (subscriptionTypes === "f"
        ? false
        : subscriptionTypes === "t"
        ? true
        : "")
  );

  // eslint-disable-next-line no-unused-vars
  const [savedFilter, setSavedFilter] = useState({});
  const [savedFilters, setSavedFilters] = useState([]);
  const [filtersSubscription, setFiltersSubscription] = useState("");

  useEffect(() => {
    if (additionalParams !== null) {
      let result = new URLSearchParams(additionalParams).toString();
      if (result === "Please+select+optionally=" || result === "null=") {
        setFiltersSubscription("");
      } else {
        setFiltersSubscription(result);
      }
    }
  }, [additionalParams]);

  useEffect(() => {
    const newFilters = filters.map((item) => ({
      description: item.FILTER_NAME,
      value: item.FILTER_SEARCH_VALUE,
    }));
    setSavedFilters(newFilters);
  }, [filters]);

  const editSubscriptionFields = {
    fields: [
      {
        name: "SUBSCRIPTION_FREQUENCY",
        type: "select",
        className: "news-country-select",
        options: [
          {
            description:
              subscriptionFrequency !== null
                ? subscriptionFrequency
                : "Please select",
            value: subscriptionFrequency
              ? subscriptionFrequency
              : "Please select",
          },
          ...filteredSubscriptionFrequency,
        ],
        required: true,
        disabled: false,
        displayProperty: "description",
        valueProperty: "value",
        label: t("frequency"),
      },
      {
        name: "SUBSCRIPTION_TYPES",
        type: "select",
        className: "news-country-select",
        options: [
          {
            description:
              subscriptionTypes === "f"
                ? "All news"
                : subscriptionTypes === "t"
                ? "Only curated news"
                : "Please select",
            value:
              subscriptionTypes === "f"
                ? "false"
                : subscriptionTypes === "t"
                ? "true"
                : "Please select",
          },
          ...filteredOptions,
        ],
        required: true,
        disabled: false,
        displayProperty: "description",
        valueProperty: "value",
        label: t("subscriptionNewsTypes"),
      },
      {
        name: "SUBSCRIPTION_SEARCH_FILTER",
        type: "select",
        className: "news-country-select",
        options: [
          {
            description: "Please select optionally",
            value: "Please select optionally",
          },
          ...savedFilters,
        ],
        required: true,
        disabled: false,
        displayProperty: "description",
        valueProperty: "value",
        label: t("searchFilterSubscription"),
      },
    ],
    findFormErrors: (form) => {
      const { SUBSCRIPTION_FREQUENCY, SUBSCRIPTION_TYPES } = form;
      const newsErrors = {};
      if (
        !SUBSCRIPTION_FREQUENCY ||
        SUBSCRIPTION_FREQUENCY === "" ||
        SUBSCRIPTION_FREQUENCY === null
      ) {
        newsErrors.SUBSCRIPTION_FREQUENCY =
          "Subscription Frequency is mandatory field";
      }
      if (
        !SUBSCRIPTION_TYPES ||
        SUBSCRIPTION_TYPES === "" ||
        SUBSCRIPTION_TYPES === null
      ) {
        newsErrors.SUBSCRIPTION_TYPES = "Subscription Types is mandatory field";
      }
      return newsErrors;
    },
  };

  const editedNews = useMemo(() => {
    return regulatoryStream.find((item) => item.id === editNewsModal);
  }, [editNewsModal, regulatoryStream]);

  const [formErrors, setFormErrors] = useState({});

  const editNewsFields = {
    fields: [
      {
        name: "NEWS_TITLE",
        type: "text",
        className: "news-title-text-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsTitle"),
        placeholder: t("newsTitlePlaceholder"),
      },
      {
        name: "NEWS_URL",
        type: "text",
        className: "news-url-text-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsURL"),
        placeholder: t("newsURLPlaceholder"),
      },
      {
        name: "NEWS_DESCRIPTION",
        type: "textarea",
        className: "news-description-textarea-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsDescription"),
        placeholder: t("newsDescriptionPlaceholder"),
      },
      {
        name: "NEWS_CONTENT",
        type: "textarea",
        className: "news-content-textarea-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsContent"),
        placeholder: t("newsContentPlaceholder"),
      },
      {
        name: "NEWS_PUBLISHER",
        type: "text",
        className: "news-publisher-text-field",
        required: true,
        classnameofgroup: "add-news-half-width-fields-group",
        label: t("newsPublisher"),
        placeholder: t("newsPublisherPlaceholder"),
      },
      {
        name: "NEWS_PUBLISHER_TYPE",
        type: "select",
        className: "news-publisher-type-select",
        classnameofgroup: "add-news-half-width-fields-group",
        options: [
          { description: "Please select", value: "Please select" },
          ...publisherTypesDataSet,
        ],
        required: true,
        disabled: false,
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsPublisherType"),
      },
      {
        name: "NEWS_PUBLICATION_TYPE",
        type: "select",
        className: "news-publication-type-select",
        classnameofgroup: "add-news-half-width-fields-group",
        required: true,
        disabled: false,
        options: [
          { description: "Please select", value: "Please select" },
          ...publicationTypesDataSet,
        ],
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsPublicationType"),
      },
      {
        name: "NEWS_DATE",
        type: "date",
        className: "news-date-field",
        classnameofgroup: "add-news-half-width-fields-group",
        label: t("newsDate"),
        required: true,
        options: [
          {
            key: "news-date",
            name: "NEWS_DATE",
            format: "YYYY/MM/DD",
            type: "date",
            disabled: false,
            value: formatDate(newsDateEditForm),
            onChangeDate: (value) => {
              setNewsDateEditForm(new Date(value));
            },
          },
        ],
      },
      {
        name: "NEWS_COUNTRY",
        type: "select",
        className: "news-country-select",
        classnameofgroup: "add-news-half-width-fields-group",
        options: [
          { description: "Please select", value: "Please select" },
          ...countriesDataSet,
        ],
        required: true,
        disabled: false,
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsCountry"),
      },
      {
        name: "NEWS_TOPICS",
        type: "multi-select",
        className: "news-topics-type-multiselect",
        classnameofgroup: "add-news-half-width-fields-group",
        required: true,
        disabled: false,
        options: topicsAndUnitsDataSet,
        selectedOptions: newsTopicsEditForm,
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsTopics"),
        placeholder: t("newsTopicsPlaceholder"),
        onMultiSelectOptionChanged: (value, description) => {
          let found = newsTopicsEditForm.find((el) => {
            return el.value === value;
          });

          if (!found) {
            setNewsTopicsEditForm((newsTopicsEditForm) => [
              ...newsTopicsEditForm,
              {
                description: description,
                value: value,
              },
            ]);
          }
        },
        onMultiSelectOptionRemoved: (value) => {
          setNewsTopicsEditForm(
            newsTopicsEditForm.filter((o) => o.value !== value)
          );
        },
      },
      {
        name: "NEWS_CURATED",
        type: "select",
        className: "news-curated-select",
        classnameofgroup: "add-news-half-width-fields-group",
        required: true,
        disabled: false,
        options: [
          { description: "Please select", value: "Please select" },
          { description: "No", value: "no" },
          { description: "Yes", value: "yes" },
        ],
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsCurated"),
      },
    ],

    findFormErrors: (form) => {
      const {
        NEWS_DESCRIPTION,
        NEWS_TITLE,
        NEWS_URL,
        NEWS_PUBLISHER,
        NEWS_PUBLISHER_TYPE,
        NEWS_PUBLICATION_TYPE,
        NEWS_COUNTRY,
        NEWS_CURATED,
      } = form;
      const newsErrors = {};

      if (!NEWS_TITLE || NEWS_TITLE === "") {
        newsErrors.NEWS_TITLE = "News title is mandatory field";
      }
      if (!NEWS_URL || NEWS_URL === "") {
        newsErrors.NEWS_URL = "News URL is mandatory field";
      }
      // if (!NEWS_DESCRIPTION || NEWS_DESCRIPTION === "") {
      //   newsErrors.NEWS_DESCRIPTION = "News description is mandatory field";
      // }
      if (NEWS_DESCRIPTION && NEWS_DESCRIPTION.length > 1500)
        newsErrors.NEWS_DESCRIPTION =
          "News description can't be longer than 1500 charachteres";
      if (!NEWS_PUBLISHER || NEWS_PUBLISHER === "") {
        newsErrors.NEWS_PUBLISHER = "News publisher is mandatory field";
      }
      if (
        !NEWS_PUBLISHER_TYPE ||
        NEWS_PUBLISHER_TYPE === "" ||
        NEWS_PUBLISHER_TYPE === "Please select"
      ) {
        newsErrors.NEWS_PUBLISHER_TYPE =
          "News publisher type is mandatory field";
      }
      if (
        !NEWS_PUBLICATION_TYPE ||
        NEWS_PUBLICATION_TYPE === "" ||
        NEWS_PUBLICATION_TYPE === "Please select"
      ) {
        newsErrors.NEWS_PUBLICATION_TYPE =
          "News publication type is mandatory field";
      }
      if (
        !NEWS_COUNTRY ||
        NEWS_COUNTRY === "" ||
        NEWS_COUNTRY === "Please select"
      ) {
        newsErrors.NEWS_COUNTRY = "News country is mandatory field";
      }
      if (
        !NEWS_CURATED ||
        NEWS_CURATED === "" ||
        NEWS_CURATED === "Please select"
      ) {
        newsErrors.NEWS_CURATED = "News curated is mandatory field";
      }
      setFormErrors(newsErrors);
      return newsErrors;
    },

    onSubmit: (values) => {
      let newsTopicsArr = [];
      newsTopicsEditForm.map((item) => newsTopicsArr.push(item.description));
      let newsTopicsString = newsTopicsArr.join(";");

      let editNewsValues = {
        ...values,
        NEWS_ID: editNewsModal,
        NEWS_TOPICS: newsTopicsString,
        NEWS_DATE: formatDate(newsDateEditForm),
        NEWS_CURATED: values?.NEWS_CURATED || "no",
      };

      let axiosConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let bodyFormData = new FormData();
      bodyFormData.append("usertoken", userToken);
      bodyFormData.append("news_title", editNewsValues.NEWS_TITLE);
      bodyFormData.append("description", editNewsValues.NEWS_DESCRIPTION);
      bodyFormData.append("content", editNewsValues.NEWS_CONTENT);
      bodyFormData.append("country", editNewsValues.NEWS_COUNTRY);
      bodyFormData.append("url", editNewsValues.NEWS_URL);
      bodyFormData.append(
        "publication_type",
        editNewsValues.NEWS_PUBLICATION_TYPE
      );
      bodyFormData.append("publisher", editNewsValues.NEWS_PUBLISHER);
      bodyFormData.append("publisher_type", editNewsValues.NEWS_PUBLISHER_TYPE);
      bodyFormData.append("publication_date", editNewsValues.NEWS_DATE);
      bodyFormData.append(
        "topics",
        newsTopicsString
        // singleTopic.TOPIC_SEARCHTAGS + ";" + editNewsValues.NEWS_TOPICS
      );
      bodyFormData.append("curated", editNewsValues.NEWS_CURATED);
      bodyFormData.append("news_id", editNewsValues.NEWS_ID);

      const asString = new URLSearchParams(bodyFormData).toString();

      axios
        .post(EDIT_NEWS, asString, axiosConfig)
        .then((response) => {
          dispatch(editNewsItemAction(response.data.RegHub_response));
          dispatch(
            filterSuccessMessageRaised("The news has been edited successfully.")
          );
          setEditNewsModal(false);

          dispatch(regulatoryStreamsAreClean());
          setPage(0);
        })
        .catch((err) => {
          dispatch(
            filterFailureMessageRaised(err.response ? err.response.data : err)
          );
          setEditNewsModal(true);
        });
      setEditNewsModal(false);
    },
  };

  const resetParams = useCallback((e) => {
    if (e) e.preventDefault();
    setFreeText("");
    setPublicationTypes([]);
    setToDate(new Date());
    setFromDate(() => {
      let d = new Date();
      d.setDate(d.getDate() - 90);
      return d;
    });
    setPublisherTypes([]);
    setCountries([]);
    setTopicsAndUnits([]);
    setSortField("");
    setSortDirection("DESC");
    setMultiFilterRadioButtonsValue("today - 90");
  }, []);

  const tabsObject = {
    classNameOfTabContainer: "tabs-main-container",
    classNameOfTabs: "main-tabs",
    defaultActiveKey: "newsflow",
    tabs: [
      {
        disabled: false,
        eventKey: "newsflow",
        tabClassName: "main-tab overviewTab",
        title: t("newsflow"),
        component:
          !loggedIn && singleTopic.TOPIC_AUDIENCE === WORKSPACE_TYPE_PRIVATE ? (
            <Container className="three-level-message-with-register topic">
              <div className="three-level-message">
                <span className="three-lvl-msg-with-register-message fs-20">
                  {t("thisTopicIsAvailableForRegisteredUser")}
                </span>
                <Link to={REGISTER}>
                  <Button
                    as="input"
                    type="button"
                    value={t("register")}
                    variant="cyan-green"
                    className="header-button three-level-rgst-button fs-14"
                  />
                </Link>
                <span className="three-level-msg-logIn-container">
                  <span className="three-lvl-msg-log-in-first-label">
                    {t("haveAnAccount")}
                  </span>
                  <Link to={LOG_IN}>
                    <span className="three-lvl-msg-log-in-second-label cursor-pointer">
                      {" " + t("logIn")}
                    </span>
                  </Link>
                </span>
              </div>
            </Container>
          ) : width > 1024 && !isIPad13 ? (
            <>
              <OverviewLargeScreenContainer
                graphAggregationsDetailsFormatted={
                  graphAggregationsDetailsFormatted
                }
                setSortField={setSortField}
                setAskAQuestionModal={setAskAQuestionModal}
                setAddNewsModal={setAddNewsModal}
                setEditNewsModal={setEditNewsModal}
                showDeleteNewsModal={showDeleteNewsModal}
                handlePagination={handlePagination}
                filterSuccessMessage={filterSuccessMessage}
                filterFailureMessage={filterFailureMessage}
                publicationTypesDataSet={publicationTypesDataSet}
                publisherTypesDataSet={publisherTypesDataSet}
                countriesDataSet={countriesDataSet}
                topicsAndUnitsDataSet={topicsAndUnitsDataSet}
                setCountries={setCountries}
                setTopicsAndUnits={setTopicsAndUnits}
                setPublicationTypes={setPublicationTypes}
                setPublisherTypes={setPublisherTypes}
                countries={countries}
                topicsAndUnits={topicsAndUnits}
                publicationTypes={publicationTypes}
                publisherTypes={publisherTypes}
                setFromDate={setFromDate}
                setToDate={setToDate}
                setFreeText={setFreeText}
                freeText={freeText}
                preparationOfDataBeforeOperation={
                  preparationOfDataBeforeOperation
                }
                setRaiseSaveFilterModal={setRaiseSaveFilterModal}
                multiFilterRadioButtonsValue={multiFilterRadioButtonsValue}
                setMultiFilterRadioButtonsValue={
                  setMultiFilterRadioButtonsValue
                }
                applyFilter={applyFilter}
                resetParams={resetParams}
                fromDate={fromDate}
                toDate={toDate}
                filters={filters}
                setChangeRadioButtonValue={setChangeRadioButtonValue}
                changeRadioButtonValue={changeRadioButtonValue}
                setRaiseManageFiltersModal={setRaiseManageFiltersModal}
                setPage={setPage}
              />
              <CustomModal
                titleOfModal={t("saveFilterSet")}
                positiveButton={t("saveFilter")}
                negativeButton={t("cancel")}
                isShown={raiseSaveFilterModal}
                setIsShown={setRaiseSaveFilterModal}
                negativeAction={() => {
                  setRaiseSaveFilterModal(false);
                  setFilterAudience(WORKSPACE_TYPE_PRIVATE);
                  setFilterName("");
                }}
                isBackdrop="static"
                isCentered={true}
                classNameOfModal={
                  currentWorkspace.WORKSPACE_TYPE === WORKSPACE_TYPE_PRIVATE
                    ? "reghub-modal add-new-filter-modal add-new-filter-modal-private"
                    : "reghub-modal add-new-filter-modal"
                }
                positiveAction={() => setSubmitForCreationOfFilterOccured(true)}
                formId="add-new-filter-form"
                content={
                  <FieldsInForm
                    idOfForm="add-new-filter-form"
                    fields={argsForCreationOfNewFilterSet.fields}
                    onSubmit={argsForCreationOfNewFilterSet.onSubmit}
                    findFormErrors={
                      argsForCreationOfNewFilterSet.findFormErrors
                    }
                    setSubmitOccurred={setSubmitForCreationOfFilterOccured}
                    submitOccurred={submitForCreationOfFilterOccured}
                  />
                }
              />
              <CustomModal
                titleOfModal={t("manageFilterSets")}
                negativeButton={t("close")}
                negativeAction={() => setRaiseManageFiltersModal(false)}
                isShown={raiseManageFiltersModal}
                setIsShown={setRaiseManageFiltersModal}
                isBackdrop="static"
                isCentered={true}
                classNameOfModal="reghub-modal manage-filters-modal"
                content={
                  <FieldsInForm fields={argsForManageFilterSets.fields} />
                }
              />
            </>
          ) : (
            <>
              <OverviewSmallScreenContainer
                graphAggregationsDetailsFormatted={
                  graphAggregationsDetailsFormatted
                }
                setSortField={setSortField}
                setAddNewsModal={setAddNewsModal}
                setEditNewsModal={setEditNewsModal}
                showDeleteNewsModal={showDeleteNewsModal}
                handlePagination={handlePagination}
                filterSuccessMessage={filterSuccessMessage}
                filterFailureMessage={filterFailureMessage}
                publicationTypesDataSet={publicationTypesDataSet}
                publisherTypesDataSet={publisherTypesDataSet}
                countriesDataSet={countriesDataSet}
                topicsAndUnitsDataSet={topicsAndUnitsDataSet}
                setCountries={setCountries}
                setTopicsAndUnits={setTopicsAndUnits}
                setPublicationTypes={setPublicationTypes}
                setPublisherTypes={setPublisherTypes}
                countries={countries}
                topicsAndUnits={topicsAndUnits}
                publicationTypes={publicationTypes}
                publisherTypes={publisherTypes}
                setFromDate={setFromDate}
                setToDate={setToDate}
                setFreeText={setFreeText}
                freeText={freeText}
                preparationOfDataBeforeOperation={
                  preparationOfDataBeforeOperation
                }
                setRaiseSaveFilterModal={setRaiseSaveFilterModal}
                multiFilterRadioButtonsValue={multiFilterRadioButtonsValue}
                setMultiFilterRadioButtonsValue={
                  setMultiFilterRadioButtonsValue
                }
                applyFilter={applyFilter}
                resetParams={resetParams}
                fromDate={fromDate}
                toDate={toDate}
                filters={filters}
                setChangeRadioButtonValue={setChangeRadioButtonValue}
                changeRadioButtonValue={changeRadioButtonValue}
                setRaiseManageFiltersModal={setRaiseManageFiltersModal}
                setPage={setPage}
              />
              <CustomModal
                titleOfModal={t("saveFilterSet")}
                positiveButton={t("saveFilter")}
                negativeButton={t("cancel")}
                isShown={raiseSaveFilterModal}
                setIsShown={setRaiseSaveFilterModal}
                negativeAction={() => {
                  setRaiseSaveFilterModal(false);
                  setFilterAudience(WORKSPACE_TYPE_PRIVATE);
                  setFilterName("");
                }}
                isBackdrop="static"
                isCentered={true}
                classNameOfModal={
                  currentWorkspace.WORKSPACE_TYPE === WORKSPACE_TYPE_PRIVATE
                    ? "reghub-modal add-new-filter-modal add-new-filter-modal-private sm-modal"
                    : "reghub-modal add-new-filter-modal sm-modal"
                }
                positiveAction={() => setSubmitForCreationOfFilterOccured(true)}
                formId="add-new-filter-form"
                content={
                  <FieldsInForm
                    idOfForm="add-new-filter-form"
                    fields={argsForCreationOfNewFilterSet.fields}
                    onSubmit={argsForCreationOfNewFilterSet.onSubmit}
                    findFormErrors={
                      argsForCreationOfNewFilterSet.findFormErrors
                    }
                    setSubmitOccurred={setSubmitForCreationOfFilterOccured}
                    submitOccurred={submitForCreationOfFilterOccured}
                  />
                }
              />
              <CustomModal
                titleOfModal={t("manageFilterSets")}
                negativeButton={t("close")}
                negativeAction={() => setRaiseManageFiltersModal(false)}
                isShown={raiseManageFiltersModal}
                setIsShown={setRaiseManageFiltersModal}
                isBackdrop="static"
                isCentered={true}
                classNameOfModal="reghub-modal manage-filters-modal sm-modal"
                content={
                  <FieldsInForm fields={argsForManageFilterSets.fields} />
                }
              />
            </>
          ),
      },
      {
        disabled: false,
        eventKey: "assessment",
        tabClassName: "main-tab assessmentTab",
        title: t("assessment"),
        component:
          !loggedIn && singleTopic.TOPIC_AUDIENCE === WORKSPACE_TYPE_PRIVATE ? (
            <Container className="three-level-message-with-register topic">
              <div className="three-level-message">
                <span className="three-lvl-msg-with-register-message fs-20">
                  {t("thisTopicIsAvailableForRegisteredUser")}
                </span>
                <Link to={REGISTER}>
                  <Button
                    as="input"
                    type="button"
                    value={t("register")}
                    variant="cyan-green"
                    className="header-button three-level-rgst-button fs-14"
                  />
                </Link>
                <span className="three-level-msg-logIn-container">
                  <span className="three-lvl-msg-log-in-first-label">
                    {t("haveAnAccount")}
                  </span>
                  <Link to={LOG_IN}>
                    <span className="three-lvl-msg-log-in-second-label cursor-pointer">
                      {" " + t("logIn")}
                    </span>
                  </Link>
                </span>
              </div>
            </Container>
          ) : (
            <>
              <AssessmentContainer singleTopic={singleTopic} />
            </>
          ),
      },
    ],
  };

  const argsForEditTopicDialog = {
    findFormErrors: (form) => {
      let SEARCH_CRITERIA = getTopicNameFromStorage;
      const { TOPIC_NAME } = form;
      const newErrors = {};

      if (!TOPIC_NAME) newErrors.TOPIC_NAME = t("topicNameIsMandatoryField");
      if (!SEARCH_CRITERIA)
        newErrors.SEARCH_CRITERIA = t("topicNameIsMandatoryField");

      return newErrors;
    },
    fields: [
      {
        name: "TOPIC_NAME",
        type: "text-field",
        required: true,
        label: t("nameOfTopic"),
        placeholder: t("egRiskManagement"),
      },
      {
        name: "SEARCH_CRITERIA",
        type: "textarea",
        required: false,
        label: t("searchCriteria"),
        placeholder: t("pleaseAddSearchCriteria"),
      },
    ],
    onSubmit: (values) => {
      updateCustomTopic(
        userToken,
        values.TOPIC_NAME,
        values.SEARCH_CRITERIA,
        true,
        user.USER_EMAIL,
        currentWorkspace.WORKSPACE_TYPE === WORKSPACE_TYPE_PRIVATE
          ? "private"
          : "public",
        singleTopic.TOPIC_ID
      );
      setIsAddEditDialogShown(false);
      setEditTopicOccurred(false);
    },
  };

  const onShareClick = () => {
    setIsShared(true);

    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      return navigator.clipboard.writeText(window.location.href);
    } else {
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = window.location.href;
      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        // here the magic happens
        document.execCommand("copy") ? res() : rej();
        textArea.remove();
      });
    }
  };

  const onShareClose = () => {
    setIsShared(false);
  };

  const deleteTopic = () => {
    deleteTopicGroup(userToken, user.USER_EMAIL, singleTopic.TOPIC_ID);
    history.goBack();
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function preparationOfDataBeforeOperation(
    type,
    FILTER_NAME,
    publicationTypesParam,
    countriesParam,
    topicsAndUnitsParam,
    publisherTypesParam,
    freeTextParam,
    from_dateParam,
    to_dateParam,
    newsValues,
    editNewsValues
  ) {
    let countriesMultipleString = "";
    let publicationTypesString = "";
    let publisherTypesString = "";
    let topicsAndUnitsTypesString = "";

    countries.forEach((country) => {
      countriesMultipleString += country.description + ";";
    });

    publicationTypes.forEach((publicationType) => {
      publicationTypesString += publicationType.description + ";";
    });

    publisherTypes.forEach((publisherType) => {
      publisherTypesString += publisherType.description + ";";
    });

    topicsAndUnits.forEach((topicOrUnit) => {
      topicsAndUnitsTypesString += topicOrUnit.description + ";";
    });
    setPage(0);
    if (type === "clearTextField") {
      console.log("type === clearTextField");
      getRegulatoryStream(
        userToken,
        singleTopic.TOPIC_ID,
        "",
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesString,
        formatDate(fromDate),
        formatDate(toDate),
        publisherTypesString,
        countriesMultipleString,
        topicsAndUnitsTypesString,
        STREAM_PAGE_NUMBER,
        STREAM_PAGE_MAX_SIZE,
        sortField,
        sortDirection
      );

      getTop5Publisher(
        userToken,
        "",
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesString,
        formatDate(fromDate),
        formatDate(toDate),
        publisherTypesString,
        countriesMultipleString,
        topicsAndUnitsTypesString
      );
      getTop5Countries(
        userToken,
        "",
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesString,
        formatDate(fromDate),
        formatDate(toDate),
        publisherTypesString,
        countriesMultipleString,
        topicsAndUnitsTypesString
      );
      getHotTopicsPerBusiness(
        userToken,
        "",
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesString,
        formatDate(fromDate),
        formatDate(toDate),
        publisherTypesString,
        countriesMultipleString,
        topicsAndUnitsTypesString
      );
      getGraphAggregations(
        userToken,
        "",
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesString,
        formatDate(fromDate),
        formatDate(toDate),
        publisherTypesString,
        countriesMultipleString,
        topicsAndUnitsTypesString
      );
      getGraphAggregationsDetails(
        userToken,
        "",
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesString,
        formatDate(fromDate),
        formatDate(toDate),
        publisherTypesString,
        countriesMultipleString,
        topicsAndUnitsTypesString
      );
    } else if (type === "applyFilter") {
      console.log("type === applyFilter");
      // let fromData = sessionStorage.getItem(fromDate);
      // let toData = sessionStorage.getItem(toDate);
      // getRegulatoryStream(
      //   userToken,
      //   singleTopic.TOPIC_ID,
      //   freeTextParam,
      //   getTopicNameFromStorage,
      //   // singleTopic.TOPIC_SEARCHTAGS,
      //   publicationTypesParam,
      //   // formatDate(from_dateParam),
      //   fromData,
      //   // formatDate(to_dateParam),
      //   toData,
      //   publisherTypesParam,
      //   countriesParam,
      //   topicsAndUnitsParam,
      //   STREAM_PAGE_NUMBER,
      //   STREAM_PAGE_MAX_SIZE,
      //   sortField,
      //   sortDirection
      // );

      setTimeout(() => {
        dispatch(regulatoryStreamsAreClean());

        let publication = sessionStorage.getItem("publicationTypes");
        let country = sessionStorage.getItem("country");
        let publisher = sessionStorage.getItem("publisherTypes");
        let from = sessionStorage.getItem("fromDate");
        let to = sessionStorage.getItem("toDate");
        let freeTextStoredVal = sessionStorage.getItem("freeText");
        setPage(0);

        getRegulatoryStream(
          userToken,
          singleTopic.TOPIC_ID,
          freeTextStoredVal ? freeTextStoredVal : freeText,
          getTopicNameFromStorage,
          publication,
          from,
          to,
          publisher,
          country,
          topicsAndUnitsTypesString,
          STREAM_PAGE_NUMBER,
          STREAM_PAGE_MAX_SIZE,
          sortField,
          sortDirection
        );
      }, 1000);
      getTop5Publisher(
        userToken,
        freeTextParam,
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesParam,
        formatDate(from_dateParam),
        formatDate(to_dateParam),
        publisherTypesParam,
        countriesParam,
        topicsAndUnitsParam
      );
      getTop5Countries(
        userToken,
        freeTextParam,
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesParam,
        formatDate(from_dateParam),
        formatDate(to_dateParam),
        publisherTypesParam,
        countriesParam,
        topicsAndUnitsParam
      );
      getHotTopicsPerBusiness(
        userToken,
        freeTextParam,
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesParam,
        formatDate(from_dateParam),
        formatDate(to_dateParam),
        publisherTypesParam,
        countriesParam,
        topicsAndUnitsParam
      );
      getGraphAggregations(
        userToken,
        freeTextParam,
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesParam,
        formatDate(from_dateParam),
        formatDate(to_dateParam),
        publisherTypesParam,
        countriesParam,
        topicsAndUnitsParam
      );
      getGraphAggregationsDetails(
        userToken,
        freeTextParam,
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesParam,
        formatDate(from_dateParam),
        formatDate(to_dateParam),
        publisherTypesParam,
        countriesParam,
        topicsAndUnitsParam
      );
    } else if (type === "getRegulatoryStream") {
      console.log(
        "type === getRegulatoryStream",
        type === "getRegulatoryStream"
      );
      // sessionStorage.setItem("freeText", freeText);

      setTimeout(() => {
        // if (getTopicNameFromStorage === null) {
        dispatch(regulatoryStreamsAreClean());
        // }
        let publication = sessionStorage.getItem("publicationTypes");
        let country = sessionStorage.getItem("country");
        let publisher = sessionStorage.getItem("publisherTypes");
        let from = sessionStorage.getItem("fromDate");
        let to = sessionStorage.getItem("toDate");

        if (page !== 1 || page < 1) {
          getRegulatoryStream(
            userToken,
            singleTopic.TOPIC_ID,
            freeText,
            getTopicNameFromStorage,
            publication,
            from,
            to,
            publisher,
            country,
            topicsAndUnitsTypesString,
            STREAM_PAGE_NUMBER,
            STREAM_PAGE_MAX_SIZE,
            sortField,
            "DESC"
          );
        }
      }, 900);

      getTop5Publisher(
        userToken,
        freeText,
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesString,
        formatDate(fromDate),
        formatDate(toDate),
        publisherTypesString,
        countriesMultipleString,
        topicsAndUnitsTypesString
      );
      getTop5Countries(
        userToken,
        freeText,
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesString,
        formatDate(fromDate),
        formatDate(toDate),
        publisherTypesString,
        countriesMultipleString,
        topicsAndUnitsTypesString
      );
      getHotTopicsPerBusiness(
        userToken,
        freeText,
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesString,
        formatDate(fromDate),
        formatDate(toDate),
        publisherTypesString,
        countriesMultipleString,
        topicsAndUnitsTypesString
      );

      getGraphAggregations(
        userToken,
        freeText,
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesString,
        formatDate(fromDate),
        formatDate(toDate),
        publisherTypesString,
        countriesMultipleString,
        topicsAndUnitsTypesString
      );
      getGraphAggregationsDetails(
        userToken,
        freeText,
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesString,
        formatDate(fromDate),
        formatDate(toDate),
        publisherTypesString,
        countriesMultipleString,
        topicsAndUnitsTypesString
      );
    } else if (type === "addFilter") {
      console.log("type === addFilter");
      let filter_search_value = {
        freeText: freeText,
        publicationTypes: publicationTypesString,
        countries: countriesMultipleString,
        publisherTypes: publisherTypesString,
        topicsAndUnits: topicsAndUnitsTypesString,
        from_date:
          multiFilterRadioButtonsValue === "custom"
            ? formatDate(fromDate)
            : multiFilterRadioButtonsValue,
        to_date:
          multiFilterRadioButtonsValue === "custom"
            ? formatDate(toDate)
            : "today",
      };
      setSavedFilter(filter_search_value);

      addFilter(
        userToken,
        FILTER_NAME,
        singleTopic.TOPIC_ID,
        filter_search_value,
        filter_audience
      );

      setFilterAudience("private");
      setFilterName("");
      setRaiseSaveFilterModal(false);
    } else if (type === "addNewsItem") {
      console.log("type === addNewsItem");
      let axiosConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let string = formatDate(newsDate);

      let dataCheck;
      if (singleTopic.TOPIC_SEARCHTAGS !== newsValues.NEWS_TOPICS) {
        dataCheck = singleTopic.TOPIC_SEARCHTAGS + ";" + newsValues.NEWS_TOPICS;
      } else {
        dataCheck = singleTopic.TOPIC_SEARCHTAGS;
      }

      let bodyFormData = new FormData();
      bodyFormData.append("usertoken", userToken);
      bodyFormData.append("news_title", newsValues.NEWS_TITLE);
      bodyFormData.append("description", newsValues.NEWS_DESCRIPTION);
      bodyFormData.append("content", newsValues.NEWS_CONTENT);
      bodyFormData.append("country", newsValues.NEWS_COUNTRY);
      bodyFormData.append("url", newsValues.NEWS_URL);
      bodyFormData.append("publication_type", newsValues.NEWS_PUBLICATION_TYPE);
      bodyFormData.append("publisher", newsValues.NEWS_PUBLISHER);
      bodyFormData.append("publisher_type", newsValues.NEWS_PUBLISHER_TYPE);
      bodyFormData.append("publication_date", string);
      bodyFormData.append(
        "topics",
        dataCheck
        // singleTopic.TOPIC_SEARCHTAGS + ";" + newsValues.NEWS_TOPICS
      );
      bodyFormData.append("curated", newsValues.NEWS_CURATED);

      const asStringAdd = new URLSearchParams(bodyFormData).toString();

      axios
        .post(ADD_NEWS, asStringAdd, axiosConfig)
        .then((response) => {
          dispatch(addNewsItemAction(response.data.RegHub_response));
          dispatch(
            filterSuccessMessageRaised("The news has been added successfully.")
          );
        })
        .catch((err) => {
          dispatch(
            filterFailureMessageRaised(err.response ? err.response.data : err)
          );
        });
    } else if (type === "editNewsItem") {
      let axiosConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      let newsTopicsArr = [];
      newsTopicsEditForm.map((item) => newsTopicsArr.push(item.description));
      let newsTopicsString = newsTopicsArr.join(";");

      let bodyFormData = new FormData();
      bodyFormData.append("usertoken", userToken);
      bodyFormData.append("news_title", editNewsValues.NEWS_TITLE);
      bodyFormData.append("description", editNewsValues.NEWS_DESCRIPTION);
      bodyFormData.append("content", editNewsValues.NEWS_CONTENT);
      bodyFormData.append("country", editNewsValues.NEWS_COUNTRY);
      bodyFormData.append("url", editNewsValues.NEWS_URL);
      bodyFormData.append(
        "publication_type",
        editNewsValues.NEWS_PUBLICATION_TYPE
      );
      bodyFormData.append("publisher", editNewsValues.NEWS_PUBLISHER);
      bodyFormData.append("publisher_type", editNewsValues.NEWS_PUBLISHER_TYPE);
      bodyFormData.append("publication_date", editNewsValues.NEWS_DATE);
      bodyFormData.append("topics", newsTopicsString);
      bodyFormData.append("curated", editNewsValues.NEWS_CURATED);
      bodyFormData.append("news_id", editNewsValues.NEWS_ID);

      const asString = new URLSearchParams(bodyFormData).toString();

      axios
        .post(EDIT_NEWS, asString, axiosConfig)
        .then((response) => {
          dispatch(editNewsItemAction(response.data.RegHub_response));
          dispatch(
            filterSuccessMessageRaised("The news has been edited successfully.")
          );
          setEditNewsModal(false);

          // dispatch(regulatoryStreamsAreClean());
          setPage(0);
        })
        .catch((err) => {
          dispatch(
            filterFailureMessageRaised(err.response ? err.response.data : err)
          );
          setEditNewsModal(true);
        });
    }
  }

  function applyFilter(data) {
    let jsonData = JSON.parse(data),
      fromDateParam = new Date(),
      toDateParam = new Date();
    (jsonData.publicationTypes || "").split(";").forEach((publicationType) => {
      if (publicationType) {
        setPublicationTypes((publicationTypes) => [
          ...publicationTypes,
          { description: publicationType, value: publicationType },
        ]);
      }
    });

    (jsonData.countries || "").split(";").forEach((country) => {
      if (country) {
        setCountries((countries) => [
          ...countries,
          { description: country, value: country },
        ]);
      }
    });

    (jsonData.topicsAndUnits || "").split(";").forEach((topicOrUnit) => {
      if (topicOrUnit) {
        setTopicsAndUnits((topicsAndUnits) => [
          ...topicsAndUnits,
          { description: topicOrUnit, value: topicOrUnit },
        ]);
      }
    });

    (jsonData.publisherTypes || "").split(";").forEach((publisherType) => {
      if (publisherType) {
        setPublisherTypes((publisherTypes) => [
          ...publisherTypes,
          { description: publisherType, value: publisherType },
        ]);
      }
    });

    if (jsonData.from_date === "today - 7") {
      fromDateParam.setDate(fromDateParam.getDate() - 7);
      setChangeRadioButtonValue(5);
      setMultiFilterRadioButtonsValue(jsonData.from_date);
    } else if (jsonData.from_date === "today - 30") {
      fromDateParam.setDate(fromDateParam.getDate() - 30);
      setChangeRadioButtonValue(6);
      setMultiFilterRadioButtonsValue(jsonData.from_date);
    } else if (jsonData.from_date === "today - 60") {
      fromDateParam.setDate(fromDateParam.getDate() - 60);
      setChangeRadioButtonValue(7);
      setMultiFilterRadioButtonsValue(jsonData.from_date);
    } else if (jsonData.from_date === "today - 90") {
      fromDateParam.setDate(fromDateParam.getDate() - 90);
      setChangeRadioButtonValue(8);
      setMultiFilterRadioButtonsValue(jsonData.from_date);
    } else {
      fromDateParam = new Date(jsonData.from_date);
      toDateParam = new Date(jsonData.to_date);
      setChangeRadioButtonValue(9);
      setMultiFilterRadioButtonsValue("custom");
    }
    setFreeText(jsonData.freeText);

    setFromDate(fromDateParam);

    setToDate(toDateParam);

    preparationOfDataBeforeOperation(
      "applyFilter",
      "",
      jsonData.publicationTypes,
      jsonData.countries,
      jsonData.topicsAndUnits,
      jsonData.publisherTypes,
      jsonData.freeText,
      fromDateParam,
      toDateParam
    );
  }

  useEffect(() => {
    if (didParsedSearch) return;
    const searchParams = queryString.parse(search);

    if (searchParams?.freeText) {
      setFreeText(searchParams.freeText);
    }
    if (searchParams?.publicationTypes) {
      setPublicationTypes(
        searchParams?.publicationTypes
          .split(";")
          .map((type) => ({ description: type, value: type }))
      );
    }
    if (searchParams?.countries) {
      setCountries(
        searchParams?.countries
          .split(";")
          .map((type) => ({ description: type, value: type }))
      );
    }
    if (searchParams?.topicsAndUnits) {
      setTopicsAndUnits(
        searchParams?.topicsAndUnits
          .split(";")
          .map((type) => ({ description: type, value: type }))
      );
    }
    if (searchParams?.publisherTypes) {
      setPublisherTypes(
        searchParams?.publisherTypes
          .split(";")
          .map((type) => ({ description: type, value: type }))
      );
    }
    const fromDateByUrl = searchParams?.fromDate;

    const toDateByUrl = searchParams?.toDate;

    if (fromDateByUrl && toDateByUrl) {
      let fromDateParam = new Date();
      let toDateParam = new Date();
      if (fromDateByUrl === "today - 7") {
        fromDateParam.setDate(fromDateParam.getDate() - 7);
        setChangeRadioButtonValue(1);
        setMultiFilterRadioButtonsValue(fromDateByUrl);
      } else if (fromDateByUrl === "today - 30") {
        fromDateParam.setDate(fromDateParam.getDate() - 30);
        setChangeRadioButtonValue(2);
        setMultiFilterRadioButtonsValue(fromDateByUrl);
      } else if (fromDateByUrl === "today - 60") {
        fromDateParam.setDate(fromDateParam.getDate() - 60);
        setChangeRadioButtonValue(3);
        setMultiFilterRadioButtonsValue(fromDateByUrl);
      } else if (fromDateByUrl === "today - 90") {
        fromDateParam.setDate(fromDateParam.getDate() - 90);
        setChangeRadioButtonValue(4);
        setMultiFilterRadioButtonsValue(fromDateByUrl);
      } else {
        fromDateParam = new Date(fromDateByUrl);
        toDateParam = new Date(toDateByUrl);
        setChangeRadioButtonValue(5);
        setMultiFilterRadioButtonsValue("custom");
      }

      setFromDate(fromDateParam);
      setToDate(toDateParam);
    }
    setDidParsedSearch(true);
  }, [didParsedSearch, search]);

  useEffect(() => {
    let finalQuery = "?";
    if (freeText) finalQuery += `freeText=${freeText}`;
    if (fromDate)
      finalQuery += `&fromDate=${
        multiFilterRadioButtonsValue === "custom"
          ? formatDate(fromDate)
          : multiFilterRadioButtonsValue
      }`;
    if (toDate)
      finalQuery += `&toDate=${
        multiFilterRadioButtonsValue === "custom" ? formatDate(toDate) : "today"
      }`;
    if (publicationTypes.length)
      finalQuery += `&publicationTypes=${publicationTypes
        .map((type) => type.value)
        .join(";")}`;
    if (countries.length)
      finalQuery += `&countries=${countries
        .map((type) => type.value)
        .join(";")}`;
    if (topicsAndUnits.length)
      finalQuery += `&topicsAndUnits=${topicsAndUnits
        .map((type) => type.value)
        .join(";")}`;
    if (publisherTypes.length)
      finalQuery += `&publisherTypes=${publisherTypes
        .map((type) => type.value)
        .join(";")}`;
    if (selectedTab) {
      finalQuery += `&tab=${selectedTab}`;
    }
    history.replace({
      pathname,
      search: finalQuery,
    });
  }, [
    countries,
    freeText,
    fromDate,
    history,
    multiFilterRadioButtonsValue,
    pathname,
    publicationTypes,
    publisherTypes,
    toDate,
    topicsAndUnits,
    selectedTab,
  ]);

  useLayoutEffect(() => {
    let historySearch = history.location.search;
    if (historySearch.includes("assessment")) {
      setSelectedTab("assessment");
    } else {
      setSelectedTab("newsflow");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setNewsDateEditForm(editedNews?.news_date);
    if (editedNews) {
      let topics = editedNews.news_topic.filter((item) => !!item.comment);
      let formattedTopics = topics.map((item) => {
        return {
          description: item.description,
          value: item.description,
          comment: item.comment,
        };
      });
      setNewsTopicsEditForm(formattedTopics);
      sessionStorage.setItem("news_url", editedNews.news_link);
      sessionStorage.setItem("question", editedNews.news_summary);
    }
  }, [editNewsModal, editedNews]);

  useEffect(() => {
    if (topicErrorMessage) {
      setFailureMessage(topicErrorMessage);
    }

    if (topicSuccessMessage) {
      setSuccessMessage(topicSuccessMessage);
    }

    if (!didMount) {
      getSingleTopic(userToken, id);
      setDidMount(true);
    }

    if (!otherRequestCalled && didMount && Object.keys(singleTopic).length) {
      let countriesMultipleString = "";
      let publicationTypesString = "";
      let publisherTypesString = "";
      let topicsAndUnitsTypesString = "";

      countries.forEach((country) => {
        countriesMultipleString += country.description + ";";
      });

      publicationTypes.forEach((publicationType) => {
        publicationTypesString += publicationType.description + ";";
      });

      publisherTypes.forEach((publisherType) => {
        publisherTypesString += publisherType.description + ";";
      });

      topicsAndUnits.forEach((topicOrUnit) => {
        topicsAndUnitsTypesString += topicOrUnit.description + ";";
      });

      getFilterTypes(userToken);
      getFilter(userToken, singleTopic.TOPIC_ID);
      // TODO
      // console.log("otherReq :>> ");
      setTimeout(() => {
        if (getTopicNameFromStorage === null) {
          dispatch(regulatoryStreamsAreClean());
        }
        if (getTopicNameFromStorage !== null) {
          getRegulatoryStream(
            userToken,
            singleTopic.TOPIC_ID,
            freeText,
            getTopicNameFromStorage,
            publicationTypesString,
            formatDate(fromDate) !== isNaN && formatDate(fromDate),
            formatDate(toDate),
            publisherTypesString,
            countriesMultipleString,
            topicsAndUnitsTypesString,
            STREAM_PAGE_NUMBER,
            STREAM_PAGE_MAX_SIZE,
            sortField,
            "DESC"
          );
        }
      }, 1000);
      // getRegulatoryStream(
      //   userToken,
      //   singleTopic.TOPIC_ID,
      //   freeText,
      //   singleTopic.TOPIC_SEARCHTAGS,
      //   publicationTypesString,
      //   formatDate(fromDate),
      //   formatDate(toDate),
      //   publisherTypesString,
      //   countriesMultipleString,
      //   topicsAndUnitsTypesString,
      //   STREAM_PAGE_NUMBER,
      //   STREAM_PAGE_MAX_SIZE,
      //   "",
      //   ""
      // );
      getGraphAggregations(
        userToken,
        freeText,
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesString,
        formatDate(fromDate),
        formatDate(toDate),
        publisherTypesString,
        countriesMultipleString,
        topicsAndUnitsTypesString
      );
      getGraphAggregationsDetails(
        userToken,
        freeText,
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypes,
        fromDate,
        toDate,
        publisherTypes,
        countries,
        topicsAndUnits
      );
      getTop5Publisher(
        userToken,
        freeText,
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesString,
        formatDate(fromDate),
        formatDate(toDate),
        publisherTypesString,
        countriesMultipleString,
        topicsAndUnitsTypesString
      );
      getTop5Countries(
        userToken,
        freeText,
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesString,
        formatDate(fromDate),
        formatDate(toDate),
        publisherTypesString,
        countriesMultipleString,
        topicsAndUnitsTypesString
      );
      getHotTopicsPerBusiness(
        userToken,
        freeText,
        singleTopic.TOPIC_ID,
        singleTopic.TOPIC_SEARCHTAGS,
        publicationTypesString,
        formatDate(fromDate),
        formatDate(toDate),
        publisherTypesString,
        countriesMultipleString,
        topicsAndUnitsTypesString
      );
      setOtherRequestCalled(true);
      getTiles(userToken, singleTopic.TOPIC_ID);
      getTilesOfTypeLinks(userToken, singleTopic.TOPIC_ID);
      getTileTypes(userToken);
    }

    if (
      filtersTypes.length &&
      (!countriesDataSet.length ||
        !publicationTypesDataSet.length ||
        !publisherTypesDataSet.length ||
        !topicsAndUnitsDataSet.length)
    ) {
      if (
        Object.keys(filtersTypes[0]).length &&
        !publisherTypesDataSet.length
      ) {
        // ADDED alphabetical order

        const sortedPublisherTypes = Object.keys(filtersTypes[0])
          .map((publisher_type) => ({
            description: filtersTypes[0][publisher_type],
            value: filtersTypes[0][publisher_type],
          }))
          .sort((a, b) => a.description.localeCompare(b.description));

        setPublisherTypesDataSet(sortedPublisherTypes);
        // Object.keys(filtersTypes[0]).forEach((publisher_type) => {
        //   setPublisherTypesDataSet((publisherTypesDataSet) => [
        //     ...publisherTypesDataSet,
        //     {
        //       description: filtersTypes[0][publisher_type],
        //       value: filtersTypes[0][publisher_type],
        //     },
        //   ]);
        // });
      }

      if (
        Object.keys(filtersTypes[1]).length &&
        !publicationTypesDataSet.length
      ) {
        const sortedPublisherTypesDataSet = Object.keys(filtersTypes[1])
          .map((publication_type) => ({
            description: filtersTypes[1][publication_type],
            value: filtersTypes[1][publication_type],
          }))
          .sort((a, b) => a.description.localeCompare(b.description));

        setPublicationTypesDataSet(sortedPublisherTypesDataSet);
        // Object.keys(filtersTypes[1]).forEach((publication_type) => {
        //   setPublicationTypesDataSet((publicationTypesDataSet) => [
        //     ...publicationTypesDataSet,
        //     {
        //       description: filtersTypes[1][publication_type],
        //       value: filtersTypes[1][publication_type],
        //     },
        //   ]);
        // });
      }

      if (Object.keys(filtersTypes[2]).length && !countriesDataSet.length) {
        const sortedCountriesDataSet = Object.keys(filtersTypes[2])
          .map((country) => ({
            description: filtersTypes[2][country],
            value: filtersTypes[2][country],
          }))
          .sort((a, b) => a.description.localeCompare(b.description));

        setCountriesDataSet(sortedCountriesDataSet);
        // Object.keys(filtersTypes[2]).forEach((country) => {
        //   setCountriesDataSet((countriesDataSet) => [
        //     ...countriesDataSet,
        //     {
        //       description: filtersTypes[2][country],
        //       value: filtersTypes[2][country],
        //     },
        //   ]);
        // });
      }

      if (
        Object.keys(filtersTypes[3]).length &&
        !topicsAndUnitsDataSet.length
      ) {
        const sortedTopicsAndUnitsDataSet = Object.keys(filtersTypes[3])
          .map((topicOrUnit) => ({
            description: filtersTypes[3][topicOrUnit],
            value: filtersTypes[3][topicOrUnit],
          }))
          .sort((a, b) => a.description.localeCompare(b.description));

        setTopicsAndUnitsDataSet(sortedTopicsAndUnitsDataSet);
        sessionStorage.setItem(
          "topicsAndUnits",
          JSON.stringify(sortedTopicsAndUnitsDataSet)
        );
        // Object.keys(filtersTypes[3]).forEach((topicOrUnit) => {
        //   setTopicsAndUnitsDataSet((topicsAndUnitsDataSet) => [
        //     ...topicsAndUnitsDataSet,
        //     {
        //       description: filtersTypes[3][topicOrUnit],
        //       value: filtersTypes[3][topicOrUnit],
        //     },
        //   ]);
        // });
      }
    }
  }, [
    countries,
    didMount,
    filtersTypes,
    freeText,
    fromDate,
    getFilter,
    getFilterTypes,
    getGraphAggregations,
    getGraphAggregationsDetails,
    getHotTopicsPerBusiness,
    getRegulatoryStream,
    getSingleTopic,
    getTileTypes,
    getTiles,
    getTop5Countries,
    getTop5Publisher,
    id,
    otherRequestCalled,
    publicationTypes,
    publisherTypes,
    resetParams,
    singleTopic,
    toDate,
    topicErrorMessage,
    topicSuccessMessage,
    userToken,
    countriesDataSet.length,
    topicsAndUnitsDataSet.length,
    publisherTypesDataSet.length,
    publicationTypesDataSet.length,
    topicsAndUnits,
    getTopicNameFromStorage,
    dispatch,
    sortField,
    getTilesOfTypeLinks,
  ]);

  useEffect(() => {
    if (isMacOs && (macOSToDate !== toDate || macOSFromDate !== fromDate)) {
      preparationOfDataBeforeOperation("getRegulatoryStream");
      setMacOSToDate(toDate);
      setMacOSFromDate(fromDate);
    }
  }, [
    fromDate,
    toDate,
    preparationOfDataBeforeOperation,
    macOSToDate,
    macOSFromDate,
  ]);

  const formatDate2 = (date) => dayjs(date).format("DD.MM.YYYY");

  useEffect(() => {
    let graphAggregationsDetailsFormatted = [graphAggregationsDetails[0]];
    if (graphAggregationsDetails) {
      for (let i = 1; i < graphAggregationsDetails.length; i++) {
        let item = graphAggregationsDetails[i];
        let itemDate = item[0];
        let formattedItemDate = formatDate2(itemDate);
        item.shift();
        let formattedItem = [formattedItemDate, ...item];
        graphAggregationsDetailsFormatted.push(formattedItem);
      }
    }
    setGraphAggregationsDetailsFormatted(graphAggregationsDetailsFormatted);
  }, [graphAggregationsDetails]);

  useEffect(() => {
    setNewsTopics([]);
  }, [addNewsModal]);

  const sortValueRef = useRef("");
  useEffect(() => {
    if (sortField !== sortValueRef.current) {
      preparationOfDataBeforeOperation("getRegulatoryStream");
      sortValueRef.current = null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortField]);

  useEffect(() => {
    if (singleTopic.SUBSCRIPTION) {
      sessionStorage.setItem(
        "singleTopic.SUBSCRIPTION",
        singleTopic.SUBSCRIPTION
      );
    }
  }, [singleTopic.SUBSCRIPTION]);

  useEffect(() => {
    if (singleTopic.SUBSCRIPTION === "TRUE") {
      getUserSubscription(userToken, singleTopic.TOPIC_NAME);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //TODO
  // useEffect(() => {
  //   if (filterFailureMessage) {
  //     setEditNewsModal(true);
  //   }
  //   if (filterSuccessMessage) {
  //     setEditNewsModal(false);
  //     dispatch(regulatoryStreamsAreClean());
  //     // window.location.reload();
  //   }
  // }, [filterSuccessMessage, filterFailureMessage, dispatch]);

  return (
    <Container expand="lg" className="home-page-container">
      {singleTopicIsLoadedWithError ? (
        <Container expand="lg" className="home-page-container">
          <ErrorMessage message={t("404NotFound")} />
        </Container>
      ) : (
        <div className="display-none" />
      )}
      {singleTopicIsLoading ? <Loader /> : <div className="display-none" />}
      {!singleTopicIsLoadedWithError &&
        !singleTopicIsLoading &&
        Object.keys(singleTopic).length !== 0 &&
        singleTopic.constructor === Object && (
          <>
            <Row className="main-heading-row topic-heading-row">
              <img
                src={`https://app.reghub.io/im-suite/static/img/${singleTopic.TOPIC_NAME.replaceAll(
                  " ",
                  "-"
                )}.jpg`}
                width={42}
                height={39}
                alt="topic_name_img"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = "https://www.reghub.io/img/topic.jpg";
                }}
              />
              <span className={"heading heading-topic-img fs-21"}>
                {singleTopic.TOPIC_NAME}
              </span>
            </Row>
            <Row className="subline-heading-row">
              <span className={"subheading fs-10"}>
                {t("createdBy")}
                {": " + singleTopic.CREATED_BY}
              </span>
              <span className="topic-subheading-right-options fs-14">
                <span
                  className={
                    isCustomTopic
                      ? "topic-subheading-option padding-right-32 topic-subheading-options-logged-in cursor-pointer"
                      : "display-none"
                  }
                  onClick={() => setIsAddEditDialogShown(true)}
                >
                  <img width={"24px"} height={"24px"} src={iconsEdit} />
                  <span className="topic-subheading-option-label">
                    {t("edit")}
                  </span>
                </span>
                <span
                  className={
                    isCustomTopic
                      ? "topic-subheading-option padding-right-32 topic-subheading-options-logged-in cursor-pointer"
                      : "display-none"
                  }
                  onClick={() => setIsDeletedDialogOpened(true)}
                >
                  <img width={"24px"} height={"24px"} src={iconsDelete} />
                  <span className="topic-subheading-option-label">
                    {t("delete")}
                  </span>
                </span>
                <span
                  className={
                    !loggedIn
                      ? "topic-subheading-option padding-right-32 cursor-not-allowed"
                      : "topic-subheading-option padding-right-32 topic-subheading-options-logged-in cursor-pointer"
                  }
                  onClick={() => {
                    // if (loggedIn) {
                    //   if (singleTopic.SUBSCRIPTION === FALSE) {
                    //     doSubscribeToTopic(
                    //       userToken,
                    //       singleTopic.TOPIC_ID,
                    //       singleTopic.TOPIC_NAME
                    //     );
                    //   } else {
                    //     doUnsubscribeToTopic(
                    //       userToken,
                    //       singleTopic.TOPIC_ID,
                    //       singleTopic.SUBSCRIPTION_ID
                    //     );
                    //   }
                    // }
                    setSubscribeModal(true);
                  }}
                >
                  <img
                    width={"24px"}
                    height={"24px"}
                    src={
                      singleTopic.SUBSCRIPTION === FALSE
                        ? iconSubscribe
                        : iconsSubscribeChecked
                    }
                    className="topic-subheading-option-icon"
                  />
                  <span className="topic-subheading-option-label">
                    {singleTopic.SUBSCRIPTION === FALSE
                      ? t("subscribeToTopic")
                      : t("unsubscribeToTopic")}
                  </span>
                </span>
                <span
                  className={
                    !loggedIn
                      ? "topic-subheading-option padding-right-32 cursor-not-allowed"
                      : "topic-subheading-option padding-right-32 topic-subheading-options-logged-in cursor-pointer"
                  }
                >
                  <Link
                    to={GET_REGULATORY_STREAM}
                    className={
                      !loggedIn ||
                      currentWorkspace.WORKSPACE_TYPE === WORKSPACE_TYPE_PRIVATE
                        ? "topic-subheading-option no-link-decoration cursor-not-allowed"
                        : "cursor-pointer topic-subheading-options-logged-in"
                    }
                    target="_blank"
                    onClick={(event) => {
                      event.preventDefault();

                      if (
                        loggedIn &&
                        currentWorkspace.WORKSPACE_TYPE !==
                          WORKSPACE_TYPE_PRIVATE
                      ) {
                        let countriesMultipleString = "";
                        let publicationTypesString = "";
                        let publisherTypesString = "";
                        let topicsAndUnitsTypesString = "";

                        countries.forEach((country) => {
                          countriesMultipleString += country.description + ";";
                        });

                        topicsAndUnits.forEach((topicOrUnit) => {
                          topicsAndUnitsTypesString +=
                            topicOrUnit.description + ";";
                        });

                        publicationTypes.forEach((publicationType) => {
                          publicationTypesString +=
                            publicationType.description + ";";
                        });

                        publisherTypes.forEach((publisherType) => {
                          publisherTypesString +=
                            publisherType.description + ";";
                        });

                        window.open(
                          GET_REGULATORY_STREAM +
                            "?usertoken=" +
                            userToken +
                            "&topic_id=" +
                            singleTopic.TOPIC_ID +
                            "&freeText=" +
                            freeText +
                            "&topic_search_tags=" +
                            singleTopic.TOPIC_SEARCHTAGS +
                            ";" +
                            topicsAndUnitsTypesString +
                            "&publicationTypes=" +
                            publicationTypesString +
                            "&fromDate=" +
                            formatDate(fromDate) +
                            "&toDate=" +
                            formatDate(toDate) +
                            "&publisherTypes=" +
                            publisherTypesString +
                            "&countries=" +
                            countriesMultipleString +
                            "&page=" +
                            STREAM_PAGE_NUMBER +
                            "&size=" +
                            STREAM_PAGE_MAX_SIZE +
                            "&sortField=" +
                            sortField +
                            "&sortDirection=" +
                            sortDirection
                        );
                      }
                    }}
                  >
                    <img
                      width={"24px"}
                      height={"24px"}
                      src={iconsJson}
                      className="topic-subheading-option-icon"
                    />
                    <span className="topic-subheading-option-label">
                      {t("getJSONStream")}
                    </span>
                  </Link>
                </span>
                <span
                  onClick={() => onShareClick()}
                  className={
                    "topic-subheading-option cursor-pointer topic-subheading-options-logged-in"
                  }
                >
                  <img
                    width={"24px"}
                    height={"24px"}
                    src={iconsShare}
                    className="topic-subheading-option-icon"
                  />
                  <span className="topic-subheading-option-label">
                    {t("share")}
                  </span>
                </span>
              </span>
            </Row>
            <hr className="horizontal-ruler topic-horizontal-ruler" />
            <TabsCustom
              classNameOfTabs={tabsObject.classNameOfTabs}
              defaultActiveKey={tabsObject.defaultActiveKey}
              tabs={tabsObject.tabs}
              classNameOfTabContainer={tabsObject.classNameOfTabContainer}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
            />
            <Footer />
          </>
        )}
      {isCustomTopic && (
        <CustomModal
          titleOfModal={t("changeTopic")}
          positiveButton={t("edit")}
          negativeButton={t("cancel")}
          negativeAction={() => setIsAddEditDialogShown(false)}
          setIsShown={setIsAddEditDialogShown}
          isShown={isAddEditDialogShown}
          positiveAction={() => setEditTopicOccurred(true)}
          classNameOfModal="add-topic-modal"
          formId="add-topic-modal-form"
          isBackdrop="static"
          content={
            <Row className="add-topic-row">
              <Col className="add-topic-first-col">
                <span className="add-topic-first-col-label">
                  {t("newTopicFirstLabel")}
                </span>
                <FieldsInForm
                  idOfForm="add-topic-modal-form"
                  fields={argsForEditTopicDialog.fields}
                  onSubmit={argsForEditTopicDialog.onSubmit}
                  findFormErrors={argsForEditTopicDialog.findFormErrors}
                  setSubmitOccurred={setEditTopicOccurred}
                  submitOccurred={editTopicOccurred}
                  existingData={singleTopic}
                />
              </Col>
              <Col className="add-topic-second-row">
                <span className="add-topic-second-col-label">
                  {t("withSearchCriteriaYouCanSpecify")}
                  <a
                    rel="noreferrer"
                    href={REG_HUB_ADD_TOPIC}
                    className="add-topic-link"
                    target="_blank"
                  >
                    {t("thisLink")}
                  </a>
                </span>
              </Col>
            </Row>
          }
          isCentered={true}
        />
      )}
      {isCustomTopic && (
        <CustomModal
          classNameOfModal="reghub-modal"
          titleOfModal={t("deleteTopic")}
          setIsShown={setIsDeletedDialogOpened}
          isShown={isDeletedDialogOpened}
          negativeAction={() => setIsDeletedDialogOpened(false)}
          content={
            <>
              <span className="modal-dialog-row-of-text fs-14">
                {t("youAreAboutToDeleteTopic")}
              </span>
              <br />
              <span className="modal-dialog-row-of-text fs-14">
                {t("areYouSureYouWantToDeleteTopic")}
              </span>
            </>
          }
          negativeButton={t("cancel")}
          positiveButton={t("delete")}
          positiveAction={() => deleteTopic()}
          isBackdrop="static"
          isCentered={true}
        />
      )}
      {isShared && (
        <AlertMessage
          variant="success"
          onClose={() => onShareClose()}
          successHeading={t("success")}
          mainMessage={t("copyURLMessage")}
        />
      )}
      {failureMessage && (
        <AlertMessage
          variant="danger"
          onClose={() => {
            doRestartTopicMessages();
            setFailureMessage("");
          }}
          successHeading={t("failure")}
          mainMessage={failureMessage}
        />
      )}
      {successMessage && (
        <AlertMessage
          variant="success"
          onClose={() => {
            doRestartTopicMessages();
            setSuccessMessage("");
          }}
          successHeading={t("success")}
          mainMessage={successMessage}
        />
      )}

      <Modal centered={true} show={!!newsIdForDeletion} backdrop={true}>
        <Modal.Header>{t("deleteNewMessage")}</Modal.Header>

        <Modal.Footer>
          <Button
            onClick={hideDeleteNewsModal}
            className="modal-negative-button apply-bg-white-color fs-14"
          >
            {t("cancel")}
          </Button>
          <Button
            onClick={() => {
              approveDeleteNewsModal();
            }}
            className="modal-positive-button apply-bg-approx-analog-color approve-news-deletion-btn fs-14"
          >
            {t("yes")}
          </Button>
        </Modal.Footer>
      </Modal>

      <CustomModal
        onClick={() => {
          if (loggedIn) {
            doUnsubscribeToTopic(
              userToken,
              singleTopic.TOPIC_ID,
              singleTopic.SUBSCRIPTION_ID
            );
            sessionStorage.removeItem("singleTopic.SUBSCRIPTION");
            setSubscribeModal(false);
          }
        }}
        positiveButton={t("newsSaveBtn")}
        positiveAction={() => {
          setSubmitNewsOccurred(true);
          if (loggedIn) {
            doSubscribeToTopic(
              userToken,
              singleTopic.TOPIC_ID,
              singleTopic.TOPIC_NAME,
              subscriptionFrequency,
              subscriptionTypes,
              filtersSubscription
            );
          }
          setSubscribeModal(false);
          dispatch(setSubscriptionFrequency(null));
          dispatch(setSubscriptionTypes(null));
          dispatch(setAdditionalParams(null));
        }}
        titleOfModal={t("editSubscription")}
        negativeButton={t("close")}
        negativeAction={() => setSubscribeModal(false)}
        isShown={subscribeModal}
        setIsShown={setSubscribeModal}
        isBackdrop="static"
        isCentered={true}
        classNameOfModal="reghub-modal add-news-modal"
        content={
          <FieldsInForm
            idOfForm="edit-subscription-form"
            fields={editSubscriptionFields.fields}
            findFormErrors={editSubscriptionFields.findFormErrors}
            onSubmit={editSubscriptionFields.onSubmit}
            submitOccurred={submitNewsOccurred}
            setSubmitOccurred={setSubmitNewsOccurred}
          />
        }
      />
      <CustomModal
        positiveButton={t("newsSaveBtn")}
        positiveAction={() => {
          setSubmitNewsOccurred(true);
        }}
        titleOfModal={t("askaQuestion")}
        // negativeButton={t("close")}
        negativeAction={() => {
          setAskAQuestionModal(false);
          dispatch(aIResponseCloseModal());
          // sessionStorage.removeItem("separateNewsAsk");
          // sessionStorage.removeItem("reference_id");
        }}
        isShown={askAQuestionModal}
        setIsShown={setAskAQuestionModal}
        isBackdrop="static"
        isCentered={true}
        classNameOfModal="reghub-modal add-news-modal ask"
        content={
          <FieldsInForm
            idOfForm="ask-a-question-form"
            fields={askAQuestionFields.fields}
            findFormErrors={askAQuestionFields.findFormErrors}
            // onSubmit={askAQuestionFields.onSubmit}
            // submitOccurred={submitNewsOccurred}
            // setSubmitOccurred={setSubmitNewsOccurred}
          />
        }
      />
      <CustomModal
        positiveButton={t("newsSaveBtn")}
        positiveAction={() => {
          setSubmitNewsOccurred(true);
        }}
        titleOfModal={t("addNews")}
        negativeButton={t("close")}
        negativeAction={() => setAddNewsModal(false)}
        isShown={addNewsModal}
        setIsShown={setAddNewsModal}
        isBackdrop="static"
        isCentered={true}
        classNameOfModal="reghub-modal add-news-modal"
        content={
          <FieldsInForm
            idOfForm="add-news-form"
            fields={addNewsFields.fields}
            findFormErrors={addNewsFields.findFormErrors}
            onSubmit={addNewsFields.onSubmit}
            submitOccurred={submitNewsOccurred}
            setSubmitOccurred={setSubmitNewsOccurred}
          />
        }
      />
      {console.log("newsTopicsEditForm", newsTopicsEditForm)}
      {!!editNewsModal && (
        <CustomModal
          titleOfModal={t("editNews")}
          positiveButton={t("newsSaveBtn")}
          isPositiveButtonDisabled={
            Object.keys(formErrors).length > 0 || newsTopicsEditForm.length < 1
          }
          positiveAction={() => {
            setSubmitEditNewsOccurred(true);
            sessionStorage.removeItem("question");
            sessionStorage.removeItem("news_url");
            sessionStorage.removeItem("editForm");
            // dispatch(regulatoryStreamsAreClean());
            dispatch(addArrayAction(regulatoryStream));
            if (filterSuccessMessage) {
              setEditNewsModal(false);
            }
          }}
          negativeButton={t("close")}
          negativeAction={() => {
            setEditNewsModal(null);
            sessionStorage.removeItem("question");
            sessionStorage.removeItem("news_url");
            sessionStorage.removeItem("editForm");
          }}
          isShown={!!editNewsModal}
          setIsShown={setEditNewsModal}
          isBackdrop="static"
          isCentered={true}
          classNameOfModal="reghub-modal add-news-modal"
          content={
            <FieldsInForm
              existingData={{
                NEWS_TITLE: editedNews?.news_title,
                NEWS_URL: editedNews?.news_link,
                NEWS_DESCRIPTION: editedNews?.news_summary,
                NEWS_CONTENT: editedNews?.news_content,
                NEWS_PUBLISHER: editedNews?.source_name,
                NEWS_PUBLISHER_TYPE: editedNews?.source_type,
                NEWS_PUBLICATION_TYPE: editedNews?.news_type,
                NEWS_COUNTRY: editedNews?.source_country,
                // NEWS_TOPICS: "Recruiting",
                NEWS_TOPICS: editedNews?.news_topic,
                NEWS_CURATED:
                  editedNews?.news_label === "curated" ? "yes" : "no",
              }}
              idOfForm="add-news-form"
              fields={editNewsFields.fields}
              findFormErrors={editNewsFields.findFormErrors}
              onSubmit={editNewsFields.onSubmit}
              onChange={editNewsFields.onChange}
              submitOccurred={submitEditNewsOccurred}
              setSubmitOccurred={setSubmitEditNewsOccurred}
            />
          }
        />
      )}
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    userToken: state.configReducer.userToken,
    singleTopicIsLoading: state.topicReducer.singleTopicIsLoading,
    singleTopicIsLoadedWithError:
      state.topicReducer.singleTopicIsLoadedWithError,
    singleTopic: state.topicReducer.singleTopic,
    loggedIn: state.userReducer.loggedIn,
    topicErrorMessage: state.topicReducer.topicErrorMessage,
    topicSuccessMessage: state.topicReducer.topicSuccessMessage,
    filterSuccessMessage: state.filterReducer.filterSuccessMessage,
    filterFailureMessage: state.filterReducer.filterFailureMessage,
    filtersTypes: state.filterReducer.filtersTypes,
    currentWorkspace: state.configReducer.currentWorkspace,
    filters: state.filterReducer.filters,
    user: state.userReducer.user,
    graphAggregationsDetails: state.filterReducer.graphAggregationsDetails,
    regulatoryStream: state.filterReducer.regulatoryStream,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSingleTopic: bindActionCreators(getSingleTopic, dispatch),
    doRestartTopicMessages: bindActionCreators(
      doRestartTopicMessages,
      dispatch
    ),
    doSubscribeToTopic: bindActionCreators(doSubscribeToTopic, dispatch),
    getUserSubscription: bindActionCreators(getUserSubscription, dispatch),
    doUnsubscribeToTopic: bindActionCreators(doUnsubscribeToTopic, dispatch),
    getFilter: bindActionCreators(getFilter, dispatch),
    getRegulatoryStream: bindActionCreators(getRegulatoryStream, dispatch),
    getTop5Publisher: bindActionCreators(getTop5Publisher, dispatch),
    getTop5Countries: bindActionCreators(getTop5Countries, dispatch),
    getGraphAggregations: bindActionCreators(getGraphAggregations, dispatch),
    getGraphAggregationsDetails: bindActionCreators(
      getGraphAggregationsDetails,
      dispatch
    ),
    getHotTopicsPerBusiness: bindActionCreators(
      getHotTopicsPerBusiness,
      dispatch
    ),
    getFilterTypes: bindActionCreators(getFilterTypes, dispatch),
    addFilter: bindActionCreators(addFilter, dispatch),
    deleteFilter: bindActionCreators(deleteFilter, dispatch),
    deleteNewsById: bindActionCreators(deleteNewsById, dispatch),
    getTiles: bindActionCreators(getTiles, dispatch),
    getTileTypes: bindActionCreators(getTileTypes, dispatch),
    updateCustomTopic: bindActionCreators(updateCustomTopic, dispatch),
    deleteTopicGroup: bindActionCreators(deleteTopicGroup, dispatch),
    getTilesOfTypeLinks: bindActionCreators(getTilesOfTypeLinks, dispatch),
  };
};

TopicHomePageContainer.propTypes = {
  userToken: PropTypes.string.isRequired,
  getSingleTopic: PropTypes.func.isRequired,
  singleTopic: PropTypes.shape({
    CREATED_BY: PropTypes.string,
    SUBSCRIPTION: PropTypes.string,
    TOPIC_AUDIENCE: PropTypes.string,
    TOPIC_ICON_PATH: PropTypes.string,
    TOPIC_ID: PropTypes.number,
    TOPIC_NAME: PropTypes.string,
    TOPIC_SEARCHTAGS: PropTypes.string,
    TOPIC_STATUS: PropTypes.string,
    SUBSCRIPTION_ID: PropTypes.string,
    TOPIC_TYPE: PropTypes.string,
  }).isRequired,
  singleTopicIsLoading: PropTypes.bool.isRequired,
  singleTopicIsLoadedWithError: PropTypes.bool.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  topicErrorMessage: PropTypes.string.isRequired,
  topicSuccessMessage: PropTypes.string.isRequired,
  doRestartTopicMessages: PropTypes.func.isRequired,
  doSubscribeToTopic: PropTypes.func,
  getUserSubscription: PropTypes.func,
  doUnsubscribeToTopic: PropTypes.func,
  getFilter: PropTypes.func.isRequired,
  getRegulatoryStream: PropTypes.func.isRequired,
  getTop5Publisher: PropTypes.func.isRequired,
  getTop5Countries: PropTypes.func.isRequired,
  getGraphAggregations: PropTypes.func.isRequired,
  getGraphAggregationsDetails: PropTypes.func.isRequired,
  getHotTopicsPerBusiness: PropTypes.func.isRequired,
  filterSuccessMessage: PropTypes.string.isRequired,
  filterFailureMessage: PropTypes.string.isRequired,
  getFilterTypes: PropTypes.func.isRequired,
  filtersTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  addFilter: PropTypes.func.isRequired,
  currentWorkspace: PropTypes.shape({
    WORKSPACE_TYPE: PropTypes.string,
  }).isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  deleteFilter: PropTypes.func.isRequired,
  deleteNewsById: PropTypes.func.isRequired,
  getTiles: PropTypes.func.isRequired,
  getTileTypes: PropTypes.func.isRequired,
  user: PropTypes.shape({
    USER_EMAIL: PropTypes.string,
  }).isRequired,
  updateCustomTopic: PropTypes.func.isRequired,
  deleteTopicGroup: PropTypes.func.isRequired,
  graphAggregationsDetails: PropTypes.arrayOf(PropTypes.array).isRequired,
  regulatoryStream: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  getTilesOfTypeLinks: PropTypes.func.isRequired,
};

TopicHomePageContainer.defaultProps = {
  userToken: "",
  getSingleTopic: () => {},
  singleTopic: {},
  singleTopicIsLoading: false,
  singleTopicIsLoadedWithError: false,
  loggedIn: false,
  topicErrorMessage: "",
  topicSuccessMessage: "",
  doRestartTopicMessages: () => {},
  doSubscribeToTopic: () => {},
  doUnsubscribeToTopic: () => {},
  getUserSubscription: () => {},
  getFilter: () => {},
  getRegulatoryStream: () => {},
  getTop5Publisher: () => {},
  getTop5Countries: () => {},
  getGraphAggregations: () => {},
  getGraphAggregationsDetails: () => {},
  graphAggregationsDetails: [],
  getHotTopicsPerBusiness: () => {},
  filterSuccessMessage: "",
  filterFailureMessage: "",
  getFilterTypes: () => {},
  filtersTypes: [],
  addFilter: () => {},
  currentWorkspace: {},
  filters: [],
  deleteFilter: () => {},
  deleteNewsById: () => {},
  addNewsItem: () => {},
  editNewsItem: () => {},
  getTileTypes: () => {},
  user: {
    USER_EMAIL: "",
  },
  updateCustomTopic: () => {},
  deleteTopicGroup: () => {},
  regulatoryStream: [],
  getTilesOfTypeLinks: () => {},
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopicHomePageContainer);
